import $ from 'jquery'

class BlockLifeAtKing extends window.HTMLDivElement {
  constructor () {
    super()
    this.$ = $(this)
    this.resolveElements()
  }

  resolveElements () {
  }

  connectedCallback () {
  }
}

window.customElements.define('flynt-block-life-at-king', BlockLifeAtKing, {extends: 'div'})



// WEBPACK FOOTER //
// ./Components/BlockLifeAtKing/script.js